@if (consumption.isLoading()) {
  <app-dashboard-summary-card-skeleton />
} @else {
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-full w-full"
  >
    @if (consumption.error()) {
      <app-error-component class="block h-full" />
    } @else {
      <div
        class="flex gap-2 items-center"
        [ngClass]="consumption.isLoading() ? 'opacity-0 pointer-events-none' : ''"
      >
        <h4 class="flex-1">
          {{ 'cockpit.dashboard.consumptionSummaryCard.titleFirstPart' | transloco }}
          <b class="font-semibold">{{
            'cockpit.dashboard.consumptionSummaryCard.titleBoldPart' | transloco
          }}</b>
          {{
            'cockpit.dashboard.consumptionSummaryCard.titleLastPart' | transloco: { year: year() }
          }}
        </h4>
        <ui-switch-bar class="w-[78px] inline-block" [formField]="settingsForm.utilityType">
          <ui-switch-bar-option value="ELECTRICITY">
            <ng-icon name="heroBolt" size="20" class="!block" />
          </ui-switch-bar-option>
          <ui-switch-bar-option value="GAS">
            <ng-icon name="heroFire" size="20" class="!block" />
          </ui-switch-bar-option>
        </ui-switch-bar>
      </div>
      <div class="text-end">
        @if (consumption.hasValue()) {
          <app-responsive-value
            [value]="consumptionValue() === 0 ? '-' : (consumptionValue() | germanNumber: 0)"
            >{{ 'cockpit.dashboard.consumptionSummaryCard.unit' | transloco }}</app-responsive-value
          >
        }
      </div>
    }
  </div>
}
